import styled from "styled-components";

export default styled.div`
    margin-top: 0.75rem;

    &:first-child { margin-top: 0; }

    h3 {
        font-weight: bold;
        margin-bottom: 0.5rem;
    }
`;



// WEBPACK FOOTER //
// ./components/common/MiniContainer.tsx